/**
 * Returns the div DOM element for the given Draft JS block key.
 * A starting DOM node can be provided to reduce the scope of the search.
 */
export default (blockKey, startingDomNode = document) => {
    if (!startingDomNode || !blockKey) return;

    return startingDomNode.querySelector(`div[data-offset-key='${blockKey}-0-0']`);
};
